<form [formGroup]="formGroup" class="fac">
  @if (pageTitle) {
    <div class="fac-page-header">
      <b>{{ getQuestionTitle(pageTitle) }}</b>
      @if (getQuestionInstruction(pageTitle)) {
        <div class="fac-instruction">
          {{ getQuestionInstruction(pageTitle) }}
        </div>
      }
    </div>
  }
  @for (element of elements; track element.name) {
    @if (element.type === "radiogroup") {
      <div class="fac-row">
        <div class="fac-q">
          <div class="fac-q-title">
            {{ getQuestionTitle(element.title) }}
          </div>
          @if (getQuestionInstruction(element.title)) {
            <div class="fac-instruction">
              {{ getQuestionInstruction(element.title) }}
            </div>
          }
        </div>
        <div class="fac-group">
          @for (choice of element.choices; track choice.value) {
            <label class="fac-option">
              <input
                type="radio"
                [formControlName]="element.name"
                [value]="choice.value"
                (click)="onRadioClick(element.name, choice.value)"
              />
              <span class="fac-option-text">{{ choice.text }}</span>
            </label>
          }
        </div>
      </div>
    }
  }
</form>
